<template>
  <div id='app' :style="styleObject()">
    <div v-if="!isInIframe">
      <NavBarComponent/>
    </div>
    <div v-if="alert.message" :class="`alert ${alert.type}`">
      {{ alert.message }}
    </div>
    <div v-bind:style="[isInIframe ? {paddingTop: '0px'} : {paddingTop: '80px'}, {width: '100%'}]">
      <router-view/>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import NavBarComponent from './components/NavBar/NavBarComponent'
import { isInIframe } from '@/helpers'

export default {
  name: 'app',
  components: {
    NavBarComponent
  },
  computed: {
    ...mapState({ alert: state => state.alert }),
    ...mapState('survey', ['style'])
  },
  mounted: function () {
    this.getLogo()
    this.getHeroImage()
    this.getStyle()
  },
  data () {
    return {
      isInIframe: isInIframe()
    }
  },
  methods: {
    ...mapActions('survey', ['getLogo', 'getHeroImage', 'getStyle']),
    ...mapActions({ clearAlert: 'alert/clear' }),
    styleObject () {
      return {
        '--primary-color': this.style.primary.color,
        '--primary-background-color': this.style.primary.backgroundColor,
        '--primary-border-color': this.style.primary.backgroundColor,

        '--primary-color--hover': `${this.style.primary.color}DD`,
        '--primary-background-color--hover': `${this.style.primary.backgroundColor}DD`,
        '--primary-border-color--hover': `${this.style.primary.backgroundColor}DD`,

        '--primary-color--disabled': `${this.style.primary.color}AA`,
        '--primary-background-color--disabled': `${this.style.primary.backgroundColor}AA`,
        '--primary-border-color--disabled': `${this.style.primary.backgroundColor}AA`,

        '--danger-color': this.style.danger.color,
        '--danger-background-color': this.style.danger.backgroundColor,
        '--danger-border-color': this.style.danger.backgroundColor,

        '--danger-color--hover': this.style.danger.backgroundColor,
        '--danger-background-color--hover': this.style.danger.color,
        '--danger-border-color--hover': this.style.danger.backgroundColor,

        '--success-color': this.style.success.color,
        '--success-background-color': this.style.success.backgroundColor,
        '--success-border-color': this.style.success.backgroundColor,

        '--success-color--hover': this.style.success.backgroundColor,
        '--success-background-color--hover': this.style.success.color,
        '--success-border-color--hover': this.style.success.backgroundColor,

        '--warning-color': this.style.warning.color,
        '--warning-background-color': this.style.warning.backgroundColor,
        '--warning-border-color': this.style.warning.backgroundColor,

        '--warning-color--hover': this.style.warning.backgroundColor,
        '--warning-background-color--hover': this.style.warning.color,
        '--warning-border-color--hover': this.style.warning.backgroundColor,

        '--heading-1-color': this.style.h1.color,
        '--heading-1-size': this.style.h1.size,
        '--heading-2-color': this.style.h2.color,
        '--heading-2-size': this.style.h2.size,
        '--heading-3-color': this.style.h3.color,
        '--heading-3-size': this.style.h3.size,
        '--heading-4-color': this.style.h4.color,
        '--heading-4-size': this.style.h4.size
      }
    }
  },
  watch: {
    $route (to, from) {
      this.clearAlert()
    }
  }
}
</script>

<style lang="scss">
/****************************************/
/****************BUTTON*****************/
/***************************************/
.btn.primary,
button.primary {
  color: var(--primary-color) !important;
  background-color: var(--primary-background-color) !important;
  border-color: var(--primary-border-color) !important;
}

.btn.primary:disabled,
button.primary:disabled {
  color: var(--primary-color--disabled) !important;
  background-color: var(--primary-background-color--disabled) !important;
  border-color: var(--primary-border-color--disabled) !important;
}

.btn.primary:hover:not(:disabled),
button.primary:hover:not(:disabled) {
  color: var(--primary-color--hover) !important;
  background-color: var(--primary-background-color--hover) !important;
  border-color: var(--primary-border-color--hover) !important;
}

.btn.inverted,
button.inverted {
  color: var(--primary-background-color) !important;
  background-color: var(--primary-color) !important;
  border-color: var(--primary-border-color) !important;
}

.btn.inverted:hover,
button.inverted:hover {
  color: var(--primary-background-color--hover) !important;
  background-color: var(--primary-color--hover) !important;
  border-color: var(--primary-border-color--hover) !important;
}

.btn.rounded,
button.rounded {
  color: var(--primary-background-color) !important;
  background-color: var(--primary-color) !important;
  border-color: var(--primary-border-color) !important;
  border-radius: 8px !important;
}

.btn.rounded:hover,
button.rounded:hover {
  color: var(--primary-background-color--hover) !important;
  background-color: var(--primary-color--hover) !important;
  border-color: var(--primary-border-color--hover) !important;
  border-radius: 8px !important;
}

.btn.danger,
button.danger {
  color: var(--danger-background-color) !important;
  background-color: var(--danger-color) !important;
  border-color: var(--danger-border-color) !important;
}

.btn.danger:hover,
button.danger:hover {
  color: var(--danger-background-color--hover) !important;
  background-color: var(--danger-color--hover) !important;
  border-color: var(--danger-border-color--hover) !important;
}

.btn.success,
button.success {
  color: var(--success-background-color) !important;
  background-color: var(--success-color) !important;
  border-color: var(--success-border-color) !important;
}

.btn.success:hover,
button.success:hover {
  color: var(--success-background-color--hover) !important;
  background-color: var(--success-color--hover) !important;
  border-color: var(--success-border-color--hover) !important;
}

.btn.warning,
button.warning {
  color: var(--warning-background-color) !important;
  background-color: var(--warning-color) !important;
  border-color: var(--warning-border-color) !important;
}

.btn.warning:hover,
button.warning:hover {
  color: var(--warning-background-color--hover) !important;
  background-color: var(--warning-color--hover) !important;
  border-color: var(--warning-border-color--hover) !important;
}

h1 {
  color: var(--heading-1-color);
  font-size: var(--heading-1-size);
}

h2 {
  color: var(--heading-2-color);
  font-size: var(--heading-2-size);
}

h3 {
  color: var(--heading-3-color);
  font-size: var(--heading-3-size);
}

h4 {
  color: var(--heading-4-color);
  font-size: var(--heading-4-size);
}

.well {
  background-color: #fff;
  padding: 20px;
  border-radius: 10px;
}

.ant-col-textarea {
  width: 100%;
}

.left-align {
  float: left;
}

.right-align {
  float: right;
}

.btn-small {
  min-width: 120px !important;
  padding: 0 15px !important;
  height: 32px !important;
}

.btn-smaller {
  min-width: 60px !important;
  padding: 0 15px !important;
  height: 32px !important;
}

textarea {
  :placeholder-shown {
    color: #111111 !important
  }

  &:placeholder-shown {
    color: #111111 !important
  }

  ::-webkit-input-placeholder {
    color: #111111 !important
  }

  &::-webkit-input-placeholder {
    color: #111111 !important
  }

  &:placeholder {
    color: #111111 !important
  }

  :placeholder {
    color: #111111 !important
  }

  ::-webkit-input-placeholder {
    color: #111111 !important
  }
}

.mortgage_table {
  table tr:nth-child(2n) td {
    background-color: #f6f6f6;
  }

  .ant-table-cell {
    padding: 25px 20px 25px 20px;
  }
}

::-webkit-input-placeholder,
:-ms-input-placeholder,
::placeholder,
.form-placeholder,
.ant-select-selection__placeholder, {
  color: #333333;
}

.ant-textarea-selection,
.ant-select-selection {
  color: #333333;
}

.error-text {
  color: var(--danger-background-color) !important;
  font-weight: 400;
}

.danger-text {
  color: var(--danger-background-color) !important;
}

.success-text {
  color: var(--success-background-color) !important;
}

.warning-text {
  color: var(--warning-background-color) !important;
}

/*! normalize.css v2.1.3 | MIT License | git.io/normalize */
/* ==========================================================================
   HTML5 display definitions
   ========================================================================== */
/**
 * Correct `block` display not defined in IE 8/9.
 */
article,
aside,
details,
figcaption,
figure,
footer,
header,
hgroup,
main,
nav,
section,
summary {
  display: block;
}

/**
 * Correct `inline-block` display not defined in IE 8/9.
 */
audio,
canvas,
video {
  display: inline-block;
}

/**
 * Prevent modern browsers from displaying `audio` without controls.
 * Remove excess height in iOS 5 devices.
 */
audio:not([controls]) {
  display: none;
  height: 0;
}

/**
 * Address `[hidden]` styling not present in IE 8/9.
 * Hide the `template` element in IE, Safari, and Firefox < 22.
 */
[hidden],
template {
  display: none;
}

/* ==========================================================================
   Base
   ========================================================================== */
/**
 * 1. Set default font family to sans-serif.
 * 2. Prevent iOS text size adjust after orientation change, without disabling
 *    user zoom.
 */
html {
  font-family: sans-serif;
  /* 1 */
  -ms-text-size-adjust: 100%;
  /* 2 */
  -webkit-text-size-adjust: 100%;
  /* 2 */
}

/**
 * Remove default margin.
 */
body {
  margin: 0;
}

/* ==========================================================================
   Links
   ========================================================================== */
/**
 * Remove the gray background color from active links in IE 10.
 */
a {
  background: transparent;
}

/**
 * Address `outline` inconsistency between Chrome and other browsers.
 */
a:focus {
  outline: thin dotted;
}

/**
 * Improve readability when focused and also mouse hovered in all browsers.
 */
a:active,
a:hover {
  outline: 0;
}

/* ==========================================================================
   Typography
   ========================================================================== */
/**
 * Address variable `h1` font-size and margin within `section` and `article`
 * contexts in Firefox 4+, Safari 5, and Chrome.
 */
h1 {
  font-size: 2em;
  margin: 0.67em 0;
}

/**
 * Address styling not present in IE 8/9, Safari 5, and Chrome.
 */
abbr[title] {
  border-bottom: 1px dotted;
}

/**
 * Address style set to `bolder` in Firefox 4+, Safari 5, and Chrome.
 */
b,
strong {
  font-weight: bold;
}

/**
 * Address styling not present in Safari 5 and Chrome.
 */
dfn {
  font-style: italic;
}

/**
 * Address differences between Firefox and other browsers.
 */
hr {
  -moz-box-sizing: content-box;
  box-sizing: content-box;
  height: 0;
}

/**
 * Address styling not present in IE 8/9.
 */
mark {
  background: #ff0;
  color: #000;
}

/**
 * Correct font family set oddly in Safari 5 and Chrome.
 */
code,
kbd,
pre,
samp {
  font-family: monospace, serif;
  font-size: 1em;
}

/**
 * Improve readability of pre-formatted text in all browsers.
 */
pre {
  white-space: pre-wrap;
}

/**
 * Set consistent quote types.
 */
q {
  quotes: "\201C" "\201D" "\2018" "\2019";
}

/**
 * Address inconsistent and variable font size in all browsers.
 */
small {
  font-size: 80%;
}

/**
 * Prevent `sub` and `sup` affecting `line-height` in all browsers.
 */
sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sup {
  top: -0.5em;
}

sub {
  bottom: -0.25em;
}

/* ==========================================================================
   Embedded content
   ========================================================================== */
/**
 * Remove border when inside `a` element in IE 8/9.
 */
img {
  border: 0;
}

/**
 * Correct overflow displayed oddly in IE 9.
 */
svg:not(:root) {
  overflow: hidden;
}

/* ==========================================================================
   Figures
   ========================================================================== */
/**
 * Address margin not present in IE 8/9 and Safari 5.
 */
figure {
  margin: 0;
}

/* ==========================================================================
   Forms
   ========================================================================== */
/**
 * Define consistent border, margin, and padding.
 */
fieldset {
  border: 1px solid #c0c0c0;
  margin: 0 2px;
  padding: 0.35em 0.625em 0.75em;
}

/**
 * 1. Correct `color` not being inherited in IE 8/9.
 * 2. Remove padding so people aren't caught out if they zero out fieldsets.
 */
legend {
  border: 0;
  /* 1 */
  padding: 0;
  /* 2 */
}

/**
 * 1. Correct font family not being inherited in all browsers.
 * 2. Correct font size not being inherited in all browsers.
 * 3. Address margins set differently in Firefox 4+, Safari 5, and Chrome.
 */
button,
input,
select,
textarea {
  font-family: inherit;
  /* 1 */
  font-size: 100%;
  /* 2 */
  margin: 0;
  /* 3 */
}

/**
 * Address Firefox 4+ setting `line-height` on `input` using `/img` in
 * the UA stylesheet.
 */
button,
input {
  line-height: normal;
}

/**
 * Address inconsistent `text-transform` inheritance for `button` and `select`.
 * All other form control elements do not inherit `text-transform` values.
 * Correct `button` style inheritance in Chrome, Safari 5+, and IE 8+.
 * Correct `select` style inheritance in Firefox 4+ and Opera.
 */
button,
select {
  text-transform: none;
}

/**
 * 1. Avoid the WebKit bug in Android 4.0.* where (2) destroys native `audio`
 *    and `video` controls.
 * 2. Correct inability to style clickable `input` types in iOS.
 * 3. Improve usability and consistency of cursor style between image-type
 *    `input` and others.
 */
button,
html input[type="button"],
input[type="reset"],
input[type="submit"] {
  -webkit-appearance: button;
  /* 2 */
  cursor: pointer;
  /* 3 */
}

/**
 * Re-set default cursor for disabled elements.
 */
button[disabled],
html input[disabled] {
  cursor: default;
}

/**
 * 1. Address box sizing set to `content-box` in IE 8/9/10.
 * 2. Remove excess padding in IE 8/9/10.
 */
input[type="checkbox"],
input[type="radio"] {
  box-sizing: border-box;
  /* 1 */
  padding: 0;
  /* 2 */
}

/**
 * 1. Address `appearance` set to `searchfield` in Safari 5 and Chrome.
 * 2. Address `box-sizing` set to `border-box` in Safari 5 and Chrome
 *    (include `-moz` to future-proof).
 */
input[type="search"] {
  -webkit-appearance: textfield;
  /* 1 */
  -moz-box-sizing: content-box;
  -webkit-box-sizing: content-box;
  /* 2 */
  box-sizing: content-box;
}

/**
 * Remove inner padding and search cancel button in Safari 5 and Chrome
 * on OS X.
 */
input[type="search"]::-webkit-search-cancel-button,
input[type="search"]::-webkit-search-decoration {
  -webkit-appearance: none;
}

/**
 * Remove inner padding and border in Firefox 4+.
 */
button::-moz-focus-inner,
input::-moz-focus-inner {
  border: 0;
  padding: 0;
}

/**
 * 1. Remove default vertical scrollbar in IE 8/9.
 * 2. Improve readability and alignment in all browsers.
 */
textarea {
  overflow: auto;
  /* 1 */
  vertical-align: top;
  /* 2 */
}

/* ==========================================================================
   Tables
   ========================================================================== */
/**
 * Remove most spacing between table cells.
 */
table {
  border-collapse: collapse;
  border-spacing: 0;
}

@font-face {
  font-family: 'vehfont';
  src: url("./assets/fonts/webfonts/veh-regular2-webfont.woff");
}

@font-face {
  font-family: 'museo-sans';
  src: url("./assets/fonts/webfonts/MuseoSans_300-webfont.woff2");
}

@font-face {
  font-family: 'museo-sans-500';
  src: url("./assets/fonts/webfonts/MuseoSans_500-webfont.woff2");
}

@font-face {
  font-family: 'museo-slab';
  src: url("./assets/fonts/webfonts/Museo_Slab_300-webfont.woff2");
}

@font-face {
  font-family: 'poppins';
  src: url("./assets/fonts/webfonts/Poppins/Poppins-Regular.ttf");
}

@font-face {
  font-family: 'poppins-500';
  src: url("./assets/fonts/webfonts/Poppins/Poppins-Medium.ttf");
}

@font-face {
  font-family: 'icomoon';
  src: url("./assets/fonts/icomoon.eot?ylf253");
  src: url("./assets/fonts/icomoon.eot?ylf253#iefix") format("embedded-opentype"), url("./assets/fonts/icomoon.ttf?ylf253") format("truetype"), url("./assets/fonts/icomoon.woff?ylf253") format("woff"), url("./assets/fonts/icomoon.svg?ylf253#icomoon") format("svg");
  font-weight: normal;
  font-style: normal;
}

[class^="icon-"], [class*=" icon-"] {
  /* use !important to prevent issues with browser extensions that change fonts */
  font-family: 'icomoon' !important;
  speak: none;
  font-style: normal;
  font-weight: normal;
  font-variant: normal;
  text-transform: none;
  line-height: 1;
  /* Better Font Rendering =========== */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.icon-image:before {
  content: "\e95a";
}

.icon-secure:before {
  content: "\e95b";
}

.icon-pricing-circle:before {
  content: "\e956";
}

.icon-pricing-diamond:before {
  content: "\e957";
}

.icon-pricing-fiveangle:before {
  content: "\e958";
}

.icon-pricing-triangle:before {
  content: "\e959";
}

.icon-macbook:before {
  content: "\e955";
}

.icon-check-round:before {
  content: "\e954";
}

.icon-checklist-thin:before {
  content: "\e950";
}

.icon-add-thin:before {
  content: "\e951";
}

.icon-pin:before {
  content: "\e952";
}

.icon-play:before {
  content: "\e953";
}

.icon-crm-bedrijven-solid:before {
  content: "\e900";
}

.icon-crm-bedrijven:before {
  content: "\e901";
}

.icon-crm-collega-solid:before {
  content: "\e902";
}

.icon-crm-collega:before {
  content: "\e903";
}

.icon-instellingen-checklists-solid:before {
  content: "\e904";
}

.icon-instellingen-checklists:before {
  content: "\e905";
}

.icon-instellingen-gebruikers-solid:before {
  content: "\e906";
}

.icon-instellingen-gebruikers:before {
  content: "\e907";
}

.icon-instellingen-info-solid:before {
  content: "\e908";
}

.icon-instellingen-info:before {
  content: "\e909";
}

.icon-instellingen-meer:before {
  content: "\e90a";
}

.icon-instellingen-producten-solid:before {
  content: "\e90b";
}

.icon-instellingen-producten:before {
  content: "\e90c";
}

.icon-timeline-activiteit-solid:before {
  content: "\e90d";
}

.icon-timeline-activiteit:before {
  content: "\e90e";
}

.icon-timeline-docs:before {
  content: "\e90f";
}

.icon-timeline-overzicht-solid:before {
  content: "\e910";
}

.icon-timeline-stats-solid:before {
  content: "\e911";
}

.icon-timeline-stats:before {
  content: "\e912";
}

.icon-add:before {
  content: "\e913";
}

.icon-arrow-curved-left:before {
  content: "\e914";
}

.icon-arrow-curved-right:before {
  content: "\e915";
}

.icon-arrow-down:before {
  content: "\e916";
}

.icon-arrow-left:before {
  content: "\e917";
}

.icon-arrow-long-down:before {
  content: "\e918";
}

.icon-arrow-long-left:before {
  content: "\e919";
}

.icon-arrow-long-right:before {
  content: "\e91a";
}

.icon-arrow-long-up:before {
  content: "\e91b";
}

.icon-arrow-right:before {
  content: "\e91c";
}

.icon-arrow-up:before {
  content: "\e91d";
}

.icon-attachment:before {
  content: "\e91e";
}

.icon-calendar:before {
  content: "\e91f";
}

.icon-camera:before {
  content: "\e920";
}

.icon-check:before {
  content: "\e921";
}

.icon-delete-thin:before {
  content: "\e922";
}

.icon-delete-trash:before {
  content: "\e923";
}

.icon-delete:before {
  content: "\e924";
}

.icon-dots:before {
  content: "\e925";
}

.icon-download:before {
  content: "\e926";
}

.icon-edit:before {
  content: "\e927";
}

.icon-editor-bold:before {
  content: "\e928";
}

.icon-editor-italic:before {
  content: "\e929";
}

.icon-editor-strikethrough:before {
  content: "\e92a";
}

.icon-email:before {
  content: "\e92b";
}

.icon-file-doc:before {
  content: "\e92c";
}

.icon-file-pdf:before {
  content: "\e92d";
}

.icon-file-upload:before {
  content: "\e92e";
}

.icon-filter:before {
  content: "\e92f";
}

.icon-lock:before {
  content: "\e930";
}

.icon-menu-small:before {
  content: "\e931";
}

.icon-message:before {
  content: "\e932";
}

.icon-minus:before {
  content: "\e933";
}

.icon-phone:before {
  content: "\e934";
}

.icon-question:before {
  content: "\e935";
}

.icon-search:before {
  content: "\e936";
}

.icon-stats-small:before {
  content: "\e937";
}

.icon-switch:before {
  content: "\e938";
}

.icon-user-business:before {
  content: "\e939";
}

.icon-users-business:before {
  content: "\e93a";
}

.icon-vote-smiley-negative:before {
  content: "\e93b";
}

.icon-vote-smiley-positive:before {
  content: "\e93c";
}

.icon-vote-thumbs-down:before {
  content: "\e93d";
}

.icon-vote-thumbs-up:before {
  content: "\e93e";
}

.icon-workflow-advies:before {
  content: "\e93f";
}

.icon-workflow-fiscaal:before {
  content: "\e940";
}

.icon-workflow-samenstellen:before {
  content: "\e941";
}

.icon-workflow:before {
  content: "\e942";
}

.icon-app-store:before {
  content: "\e943";
}

.icon-berichten:before {
  content: "\e944";
}

.icon-conversie-app:before {
  content: "\e945";
}

.icon-crm:before {
  content: "\e946";
}

.icon-dossier:before {
  content: "\e947";
}

.icon-e-signing:before {
  content: "\e948";
}

.icon-instellingen:before {
  content: "\e949";
}

.icon-integraties:before {
  content: "\e94a";
}

.icon-mijn-producten:before {
  content: "\e94b";
}

.icon-robot-accounting:before {
  content: "\e94c";
}

.icon-single-signon:before {
  content: "\e94d";
}

.icon-timeline:before {
  content: "\e94e";
}

.icon-webwinkel:before {
  content: "\e94f";
}

/* #f5f5f8 */
/* #594E4E */
/* #ff8201 */
/* #ed1c24 */
/* #2c2895 */
/*/  BASE  /////////////////////////////////////////////////////////////////*/
* {
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  outline: 0;
}

html, body {
  -webkit-overflow-scrolling: touch;
}

html {
  width: 100%;
  height: 100%;
}

body {
  font: 16px "poppins", "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-weight: normal;
  font-style: normal;
  color: #594e4e;
  background: #f6f6f6 !important;
  position: relative;
  height: 100%;
  width: 100%;
  margin: 0;
  padding: 0;
}

#app {
  display: flex;
  flex: 1;
  background: #f6f6f6;
}

#aqopi-frame {
  width: 100%;
  height: 55vh;
}

#iwize-data-frame {
  display: block;
  width: 100%;
  height: 55vh;
  border: none;
  background-color: #f6f6f6 !important;
  border-radius: 30px;
}

h1 {
  font-family: "poppins-500", "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 2.625em;
  margin: 0 0 10px;
  padding: 0;
}

h2 {
  font-family: "poppins", "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 1.875em;
  margin: 0 0 10px;
  padding: 0;
  color: var(--heading-2-color);
  letter-spacing: 0;
}

h3 {
  font-family: "poppins", "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 1.475em;
  margin: 0 0 5px;
  padding: 0;
  color: var(--heading-3-color);
}

h4 {
  font-family: "poppins", "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 1.275em;
  margin: 0 0 5px;
  padding: 0;
  color: var(--heading-4-color);
}

p {
  font-size: 1em;
  margin: 0 0 20px;
  padding: 0;
  line-height: 1.7em;
}

a {
  color: var(--primary-background-color) !important;
}

a:hover {
  text-decoration: none;
}

img {
  border: none;
  -webkit-backface-visibility: hidden;
}

strong {
  font-family: "poppins-500", "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-weight: normal;
}

/*/  SELECTIONS & PLACEHOLDERS  ////////////////////////////////////////////////////////////////*/
p::selection, h1::selection, h2::selection, h3::selection, a::selection, li::selection, input::selection, textarea::selection, label::selection, strong::selection, span::selection, div::selection {
  background: #77777b;
  color: #fff;
}

p::-webkit-selection, h1::-webkit-selection, h2::-webkit-selection, h3::-webkit-selection, a::-webkit-selection, li::-webkit-selection, input::-webkit-selection, textarea::-webkit-selection, label::-webkit-selection, strong::-webkit-selection, span::-webkit-selection, div::-webkit-selection {
  background: #77777b;
  color: #fff;
}

p::-moz-selection, h1::-moz-selection, h2::-moz-selection, h3::-moz-selection, a::-moz-selection, li::-moz-selection, input::-moz-selection, textarea::-moz-selection, label::-moz-selection, strong::-moz-selection, span::-moz-selection, div::-moz-selection {
  background: #77777b;
  color: #fff;
}

::-webkit-input-placeholder {
  color: #594e4e;
  opacity: 0.2;
}

:-moz-placeholder {
  color: #594e4e;
  opacity: 0.2;
}

::-moz-placeholder {
  color: #594e4e;
  opacity: 0.2;
}

:-ms-input-placeholder {
  color: #9a8c8c;
}

input[type="text"], input[type="email"], input[type="file"], input[type="number"], input[type="password"], textarea {
  -webkit-appearance: none;
}

/*/  MISC  /////////////////////////////////////////////////////////////////*/
.container {
  display: flex;
  flex: 1;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 0 60px;
}

.flex {
  display: flex;
  flex: 1;
  flex-direction: row-reverse;
}

.flex-align-center {
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
}

.ant-table-row-cell:first-child {
  width: auto !important;
  padding-right: 15px;
}

.ant-picker-dropdown {
  .ant-picker-header {
    padding: 10px;
  }

  .ant-picker-date-panel {
    width: 350px !important;
    align-items: center;
  }
}

/*/  HEADER  /////////////////////////////////////////////////////////////////*/
.header {
  flex: 1;
  flex-direction: row;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 100;
  height: 80px;
  background: #fff;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);

  .container {
    height: 100%;
  }
}

.header .logo {
  height: 100%;
}

.header .logo-helper {
  display: inline-block;
  height: 100%;
  vertical-align: middle;
}

.header .logo img {
  max-width: 300px;
  max-height: 100%;
  width: auto;
  height: auto;
  vertical-align: middle;
  display: inline-block;
}

.header a.btn {
  border-radius: 15px;
  border: 1px solid var(--primary-background-color) !important;
  display: block;
  padding: 10px;
  transition: all .3s ease;
  text-decoration: none;
}

/*/  CONTENT  /////////////////////////////////////////////////////////////////*/
.content {
  background-color: #f6f6f6;
}

/*/  LOGIN  /////////////////////////////////////////////////////////////////*/
.login-bg {
  background-size: cover;
  background-position: center center;
  height: 300px;
}

.login-block {
  background: #fff;
  margin: 0 auto;
  width: 640px;
  padding: 80px;
  margin-top: -200px;
}

.debug-block {
  background: #fff;
  margin: 0 auto;
  width: 1300px;
  padding: 80px;
  margin-top: -200px;
}

.login-block form .form-group {
  margin-bottom: 10px;
}

.login-block form .form-group input {
  border: 1px solid #d7d7e3;
  width: 100%;
  height: 48px;
  line-height: 48px;
  padding: 0 10px;
}

.login-block form .form-group button {
  width: 100%;
}

.login-block form .form-group a {
  display: inline-block;
  margin: 0 auto;
}

.login-block form .form-group.link {
  text-align: center;
  padding: 20px 0 0;
  cursor: pointer;
}

.login-footer {
  position: absolute;
  bottom: 0;
  width: 100%;
}

.login-footer ul {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px 0;
  margin: 0;
}

.login-footer ul li {
  list-style: none;
  margin-left: 20px;
}

.login-footer ul li:first-child {
  margin-left: 0;
}

/*/  SIDEBAR  /////////////////////////////////////////////////////////////////*/
.sidebar {
  //
}

.sidebar_inner {
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
  margin-top: 30px;

  a.btn {
    border-radius: 555px;
    border: 1px solid var(--primary-background-color) !important;
    display: block;
    padding: 0 14px;
    line-height: 38px;
    transition: all .3s ease;
    text-decoration: none;
  }
}

.sidebar ul.steps {
  margin: 0;
  padding: 0;
}

.sidebar ul.steps li {
  list-style: none;
  display: inline-block;
  position: relative;
  padding: 0 0 0 32px;
  height: 32px;
  vertical-align: middle;
  margin-top: 15px;
}

//.sidebar ul.steps li:last-child {
//  margin: 0;
//}

.sidebar ul.steps li:last-child::before {
  height: 32px;
}

.sidebar ul.steps li::before {
  position: absolute;
  left: 16px;
  width: 1px;
  background: #d7d7e3;
  height: 50px;
  content: "";
  z-index: -1;
}

.sidebar ul.steps li .step {
  border-radius: 555px;
  border: 1px solid #594e4e;
  height: 32px;
  width: 32px;
  line-height: 32px;
  text-align: center;
  margin: 0 10px 0 0;
  background: #fff;
  position: absolute;
  left: 0;
  top: 0;
}

.sidebar ul.steps li .text {
  line-height: 32px;
  padding-left: 5px;
  padding-right: 15px;
}

.sidebar ul.steps li .line {
  width: 15px;
  margin-top: 16px;
  border-bottom: 2px solid var(--primary-background-color);
}

.sidebar ul.steps li .space {
  width: 15px;
}

.sidebar ul.steps li.active {
  font-family: "poppins-500", "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-weight: normal;
}

.sidebar ul.steps li.active::before {
  background: var(--primary-color) !important;
}

.sidebar ul.steps li.active .step {
  background: var(--primary-background-color) !important;
  color: var(--primary-color) !important;
  border: 1px solid var(--primary-background-color) !important;
}

.sidebar ul.steps li.inactive {
  color: #b7b6c0;
}

.sidebar ul.steps li.inactive .step {
  border: 1px solid #b7b6c0;
}

/*/  MAIN  /////////////////////////////////////////////////////////////////*/
.main {
  display: flex;
  flex: 1;
  flex-direction: column;
  margin: 20px 0 20px 20px;
}

.main_loading {
  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin: 50px;
}

.iframe_loading {
  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  margin: 1em 0;
}

.main .block {
  margin: 0 0 30px;
}

.main .block.block-form {
  background: #fff;
  border-radius: 10px;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
  padding: 20px;
}

.section-question {
  display: flex !important;
  flex-direction: column !important;
  align-items: flex-start !important;
}

.section-question-title {
  width: unset !important;
}

/*/  BUTTONS  /////////////////////////////////////////////////////////////////*/
button {
  background: var(--primary-color) !important;
  color: #fff;
  font-weight: normal;
  border: none;
  line-height: 40px;
  height: 40px;
  min-width: 230px;
  padding: 0 15px;
  box-shadow: 0 4px 6px 0 rgba(0, 0, 0, 0.1);
  -webkit-transition: all 0.3s ease;
  -moz-transition: all 0.3s ease;
  -o-transition: all 0.3s ease;
  transition: all 0.3s ease;
}

button.right {
  float: right;
}

button span.icon {
  font-size: .65em;
  margin-left: 10px;
}

button span.icon.icon-arrow-left {
  margin-right: 10px;
  margin-left: 0;
}

button:hover {
  box-shadow: 0 6px 10px 0 rgba(0, 0, 0, 0.25);
}

/*/  MEDIA SCREENS  /////////////////////////////////////////////////////////////////*/

.well {
  padding: 20px;
  margin-bottom: 20px;
}

.toast-mask {
  height: 0;
}

.toast {
  max-width: 570px !important;
}

/***************** INPUT ****************************/
.ant-input:hover {
  border-color: var(--primary-border-color) !important;
}

.ant-input:focus {
  border-color: var(--primary-border-color) !important;
  /*-webkit-box-shadow: 0 0 0 2px rgba(255, 130, 1, 0.2);*/
  /*box-shadow: 0 0 0 2px rgba(255, 130, 1, 0.2);*/
  -webkit-box-shadow: none !important;
  box-shadow: none !important;
}

.ant-checkbox-wrapper:hover
.ant-checkbox-inner,
.ant-checkbox:hover .ant-checkbox-inner,
.ant-checkbox-input:focus + .ant-checkbox-inner {
  border-color: var(--primary-border-color) !important;
}

.ant-checkbox-checked .ant-checkbox-inner {
  background-color: var(--primary-background-color) !important;
  border-color: var(--primary-border-color) !important;
}

.ant-form-item-label {
  white-space: normal;
}

.ant-radio-wrapper:hover .ant-radio .ant-radio-inner,
.ant-radio:hover .ant-radio-inner,
.ant-radio-focused .ant-radio-inner {
  border-color: var(--primary-border-color) !important;
}

.ant-radio-checked .ant-radio-inner {
  border-color: var(--primary-border-color) !important;
}

.ant-radio-inner::after {
  background-color: var(--primary-background-color) !important;
}

.ant-radio-checked::after {
  border-color: var(--primary-border-color) !important;
}

.ant-select-open .ant-select-selection {
  border-color: var(--primary-border-color) !important;
}

.ant-select-focused .ant-select-selection,
.ant-select-selection:focus,
.ant-select-selection:active {
  border-color: var(--primary-border-color) !important;
  /*-webkit-box-shadow: 0 0 0 2px rgba(255, 130, 1, 0.2);*/
  /*box-shadow: 0 0 0 2px rgba(255, 130, 1, 0.2);*/
  -webkit-box-shadow: none !important;
  box-shadow: none !important;
}

.ant-select-selection:hover {
  border-color: var(--primary-border-color) !important;
}

.ant-select-dropdown-menu-item-selected {
  background-color: var(--primary-background-color) !important;
}

.ant-select-dropdown-menu-item:hover {
  background-color: var(--primary-background-color) !important;
}

.ant-slider-handle {
  border: 2px solid var(--primary-border-color) !important;
}

.ant-slider-handle:focus {
  /*-webkit-box-shadow: 0 0 0 2px rgba(255, 130, 1, 0.2);*/
  /*box-shadow: 0 0 0 2px rgba(255, 130, 1, 0.2);*/
  -webkit-box-shadow: none !important;
  box-shadow: none !important;
}

.sidebar ul.steps li.inactive .step {
  cursor: not-allowed;
}

.sidebar ul.steps li.active .step,
.sidebar ul.steps li.done .step {
  cursor: pointer;
  color: var(--primary-color) !important;
  background-color: var(--primary-background-color) !important;
  border: 1px solid var(--primary-border-color) !important;
}

/***************** SLIDER ****************************/
.ant-slider-track,
.ant-slider-dot-active,
.ant-slider-dot-active,
.ant-slider-dot {
  border-color: transparent !important;
  background-color: transparent !important;
}

.ant-slider-mark-text {
  color: #333333;
}

.ant-steps-item:hover {
  .ant-steps-item-title, .ant-steps-icon {
   color: var(--primary-background-color--hover) !important;
  }

  .ant-steps-item-icon {
    border-color: var(--primary-background-color) !important;
  }
}

.ant-steps-item-description,
.ant-steps-horizontal:not(.ant-steps-label-vertical) .ant-steps-item-description {
  max-width: 200px !important;
  width: 100% !important;
}

.ant-steps-item-process .ant-steps-item-icon {
  background: var(--primary-background-color) !important;
  color: var(--primary-color) !important;
  border: 1px solid var(--primary-background-color) !important;
}

.ant-steps-item-wait > .ant-steps-item-container > .ant-steps-item-tail::after {
  background-color: transparent;
}

.ant-steps-item-finish .ant-steps-icon {
  color: var(--primary-color) !important;
}

.ant-steps-item-finish > .ant-steps-item-tail:after {
  background: var(--primary-background-color) !important;
}

.ant-steps-item-finish > .ant-steps-item-content > .ant-steps-item-title:after {
  background: var(--primary-background-color) !important;
}

.ant-steps-item-finish > .ant-steps-item-container > .ant-steps-item-tail::after {
  background: var(--primary-background-color) !important;
}

.ant-progress-success-bg, .ant-progress-bg {
  background: var(--primary-background-color) !important;
}

.ant-steps-item-finish .ant-steps-item-icon {
  background: var(--primary-background-color) !important;
  color: var(--primary-color) !important;
  border: 1px solid var(--primary-background-color) !important;
}

.text-center {
  text-align: center;
}

.text-small {
  font-size: 11px;
}

/****************************************/
/****************GENERAL*****************/
/***************************************/
li {
  list-style: none;
}

a:hover {
  text-decoration: none;
}

.ant-btn {
  border-radius: 8px !important;
}

.info-block {
  background-color: #e8e8e8;
  border-radius: 10px;
  padding: 10px;
}

/****************************************/
/**************PADDING/MARGIN************/
/***************************************/

.py-5 {
  padding: 5px 0;
}

.py-10 {
  padding: 10px 0;
}

.py-20 {
  padding: 20px 0;
}

.py-30 {
  padding: 30px 0;
}

.py-40 {
  padding: 40px 0;
}

.py-50 {
  padding: 50px 0;
}

.py-60 {
  padding: 60px 0;
}

.py-70 {
  padding: 70px 0;
}

.py-100 {
  padding: 100px 0;
}

.pt-5 {
  padding-top: 5px;
}

.pt-10 {
  padding-top: 10px;
}

.pt-20 {
  padding-top: 20px;
}

.pt-30 {
  padding-top: 30px;
}

.pt-40 {
  padding-top: 40px;
}

.pt-50 {
  padding-top: 50px;
}

.pb-5 {
  padding-bottom: 5px;
}

.pb-10 {
  padding-bottom: 10px;
}

.pb-20 {
  padding-bottom: 20px;
}

.pb-30 {
  padding-bottom: 30px;
}

.pb-40 {
  padding-bottom: 40px;
}

.pb-50 {
  padding-bottom: 50px;
}

.mt-5 {
  margin-top: 5px;
}

.mt-10 {
  margin-top: 10px;
}

.mt-15 {
  margin-top: 15px;
}

.mt-20 {
  margin-top: 20px;
}

.mb-5 {
  margin-bottom: 5px;
}

.mb-10 {
  margin-bottom: 10px;
}

.mb-15 {
  margin-bottom: 15px;
}

.mb-20 {
  margin-bottom: 20px;
}

/****************************************/
/******************STEPS*****************/
/***************************************/
.content-text {
  li {
    list-style-type: circle;
  }
}

h1, h2 {
  font-family: poppins;
  margin-bottom: 15px;
}

h3, h4 {
  font-family: poppins;
  margin-bottom: 10px;
}

input[type='range'] {
  -webkit-appearance: none;
  appearance: none;
  height: 8px;
  background: grey;
  outline: none;
}

input[type='range']::-webkit-slider-thumb {
  -webkit-appearance: none;
  appearance: none;
  width: 10px;
  height: 25px;
  background-color: var(--primary-background-color) !important;
  cursor: pointer;
}

.ant-btn-primary:hover,
.ant-btn-primary:focus {
  background-color: var(--primary-background-color) !important;
  border-color: var(--primary-border-color) !important;
}

.form-check-input {
  margin-right: 10px;
}

.prefix {
  position: absolute;
  z-index: 1;
  top: 6px;
  left: 10px;
}

.prefix-input {
  input {
    padding-left: 15px;
  }
}

.radio-choices {
  display: flex;
  flex-direction: column;
  align-items: center;

  .form-check-input {
    margin-right: 0;
  }
}

.radio-choices-label {
  .ant-col-sm-3 {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .form-check-input {
    margin-right: 52px;
  }
}

/*/  INTO  ////////////////////////////////////////////////////////////////////*/

.intro .manual,
.intro .auto,
.complete .manual,
.complete .auto {
  display: flex;
  flex-direction: column;
  background-color: #e8e8e8;
  padding: 15px;
  border-radius: 10px;
}

.intro .desc {
  min-height: 600px;
}

.intro .cta,
.complete .cta {
  text-align: center;
}

/*/  MISC  /////////////////////////////////////////////////////////////////*/

.form-check {
  display: flex;
}

.invalid-feedback {
  color: var(--danger-background-color) !important;
}

.slogan {
  padding: 0 !important;
  color: #999999 !important;
}

.inverted.ant-btn,
.primary.ant-btn {
  height: auto;
  padding: 15px;
  border-radius: 8px !important;
}

.ant-checkbox-wrapper,
.ant-radio-wrapper {
  margin-right: 10px !important;
}

.ant-table {
  font: 14px "poppins", "Helvetica Neue", Helvetica, Arial, sans-serif;
  width: 100%;
  text-align: left;
  border-radius: 4px 4px 0 0;
  border-collapse: separate;
  border-spacing: 0;
}

.ant-table-row {
  font: 14px "poppins", "Helvetica Neue", Helvetica, Arial, sans-serif;
  transition: all .3s, height 0s;
}

.ant-table-row-cell {
  font: 14px "poppins", "Helvetica Neue", Helvetica, Arial, sans-serif;
  width: 16.66%;
  overflow-wrap: break-word;
  color: #594e4e;
}

.ant-table-row-cell:first-child {
  width: 55%;
}

.ant-table-thead {
  text-align: left;
  background: #fafafa;
  border-bottom: 1px solid #e8e8e8;
  transition: background .3s ease;
}

.form-check-label {
  margin-top: 3px;
  font: 14px "poppins", "Helvetica Neue", Helvetica, Arial, sans-serif;
}

.center {
  text-align: center;
  justify-content: center;
  align-items: center;
}

.ant-modal-close {
  height: auto;
  min-width: 40px;
  box-shadow: none;
}

.ant-modal-close:hover {
  box-shadow: none;
}
.ant-calendar-picker {
  width: 100%;
}

</style>
